import { render, staticRenderFns } from "./ProcurementHall.vue?vue&type=template&id=1bda2637&scoped=true"
import script from "./ProcurementHall.vue?vue&type=script&lang=js"
export * from "./ProcurementHall.vue?vue&type=script&lang=js"
import style0 from "./ProcurementHall.vue?vue&type=style&index=0&id=1bda2637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda2637",
  null
  
)

export default component.exports